import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import "./customizedSnackbars.scss";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CustomizedSnackbars(props) {
  const { state, handleClose, text, severity, autoHideDuration = 3000 } = props;

  const [open, setOpen] = useState(state);

  useEffect(() => {
    setOpen(state);
  }, [state]);

  const handleClickLink = (e) => {
    e.preventDefault();
    window.open(props?.exportedUrl, "_blank");
  };

  const handleSnackbarClose = (event, reason) => {
    // Prevent closing when clicking outside the snackbar
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    handleClose?.();
  };

  return (
    <Stack className="cust-snackbar-wrap" spacing={2}>
      <Snackbar
        className="cust-snackbar"
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleSnackbarClose}
      >
        <Alert
          severity={severity}
          className="cust-snackbar-wrap"
          onClose={() => {
            setOpen(false);
            handleClose?.();
          }}
        >
          {props?.urlInside ? (
            <>
              {text}.
              <a
                href="#"
                onClick={handleClickLink}
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  paddingLeft: "10px",
                }}
              >
                Click Here To See.
              </a>
            </>
          ) : (
            text
          )}
        </Alert>
      </Snackbar>
    </Stack>
  );
}